<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-row dense class="align-center justify-space-between">
          <v-col cols="auto">
            <v-btn icon class="mb-2" @click="$router.push('/ru/pecuarios')">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <!-- <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn> -->
            <!-- <form-meta
            :data="registro"
            :remove-commit="'removerPecuaria'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          /> -->
            <save-btn
              class="btn-oval"
              :record-status="registro.estatus"
              :loading="loading"
              @click="antesDeGuardar"
            />
          </v-col>
        </v-row>

        <v-col cols="12">
          <!-- <span style="font-size: 30px">🐂 🐄</span> -->
          <div style="text-align: center" class="text-h4 font-weight-bold">
            {{ 'Ingreso de Ganado 🐮' }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-h7">Agrega un Ganado</div>
        </v-col>
     
      </v-row>
    
      <!-- AQUI botones de entrada, engorde, produccion y venta-->
      <template>
     
        <!--****************** CUADRO PARA VER EL INVENTARIO DE LA FINCA  ************************** -->
        <v-row class="text-left">
          <!-- Botón Agregar -->
          <!-- <v-col cols="4">
            <v-btn
              block
              outlined
              class="primary--text custom-button"
              @click="agregarProduccionYEditar"
            >
              <v-icon left>mdi-plus</v-icon>
              Agrega Ingreso
            </v-btn>
          </v-col> -->
          <!-- AQUI -->
          <v-col cols="12" v-if="indexEdicion !== null">
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="registro.id_actividad_pecuaria"
                    :no-data-text="$vuetify.noDataText"
                    :rules="[r.required]"
                    :items="actividad_pecuaria"
                    item-text="descripcion"
                    item-value="id"
                    label="Tipo de Ganado *"
                    ref="tipoGanadoSelect"
                    outlined
                    @input="handleActividadChange()"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.identirubro"
                    label="Identificador o Lote de ganado *"
                    :rules="[r.required]"
                    outlined
                  />
                </v-col>
             
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.cantidad"
                    label="Cantidad *"
                    :rules="[r.required]"
                    outlined
                  />
                </v-col>
                   <v-col cols="12">
                  <v-select
                    v-model="registro.id_finca"
                    :no-data-text="$vuetify.noDataText"
                    :items="fincas"
                    item-text="nombre"
                    item-value="id"
                    label="Finca"
                    outlined
                    @input="onFincaChange()"
                  >
                    <template slot="item" slot-scope="{ item }">
                      <finca-select-item :item="item" />
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="registro.sexo"
                    :items="sexoOptions"
                    item-text="text"
                     item-value="value"
                    outlined
                    label="Sexo"
                    :placeholder="registro.sexo ? '' : 'Sin seleccionar'"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="registro.peso_inicial"
                    :rules="[r.float, r.min_num(0)]"
                    label="Peso Inicial (Kg)"
                    outlined
                  >
                    <template v-slot:append>
                      <unit-picker
                        @transform="registro.peso_inicial = $event"
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="registro.fechanac"
                    label="Fecha de nacimiento (aaaa-mm-dd)"
                    placeholder="aaaa-mm-dd"
                    outlined
                    :error="!!errorn['fechanac']"
                    :error-messages="errorn['fechanac'] || ''"
                    @change="validarFechaNac(registro.fechanac)"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="registro.raza" outlined label="Raza" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="registro.color"
                    :items="color"
                    label="Color"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.origen"
                    outlined
                    label="Origen o Procedencia"
                  />
                </v-col>
                <v-col cols="6" md="6">
                  <v-text-field
                    v-model="registro.codigop"
                    outlined
                    label="Codigo de Padre"
                  />
                </v-col>
                <v-col cols="6" md="6">
                  <v-text-field
                    v-model="registro.codigom"
                    outlined
                    label="Codigo de Madre "
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="registro.nombre_ganado"
                    outlined
                    label="Nombre Ganado"
                  />
                </v-col>
                <v-col cols="6" md="6">
                  <v-text-field
                    v-model="registro.salida"
                    outlined
                    label="Fecha de Salida"
                    :date.sync="registro.salida"
                    placeholder="aaaa-mm-dd"
                    :error-messages="errors.salida || []"
                    @change="validarFechaSalida(registro.salida)"
                  />
                </v-col>
                <v-col cols="6" md="6">
                  <v-select
                    v-model="registro.tipo_salida"
                    :items="tipoSalidaOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="Tipo de Salida"
                    clearable
                  />
                </v-col>
                <!-- <v-col cols="12">
                  <v-select
                    v-model="
                      registro.estatus
                    "
                    label="Estatus"
                    :items="estatusOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                  >
                  </v-select>
                </v-col> -->
                <!-- <v-col cols="6" md="6" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarEntrada">
                    Siguiente
                  </v-btn>
                </v-col> -->
               <!--  <v-col cols="6" md="3" class="d-flex">
                  <v-btn icon @click="eliminarFilaProduccion(indexEdicion)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col> -->
              </v-row>
            </v-card>
          </v-col>
          <!-- TARJETAS DE ENTRADAS -->
          <v-col cols="12" v-for="(item, index) in producciones" :key="index">
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicion
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarProduccion(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Animal:</strong>
                    {{ descripcionActividad(item.id_actividad_pecuaria) || '' }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Peso Inicial: {{ item.peso_inicial }} kg - Cantidad:
                    {{ item.cantidad }} - Sexo: {{ sexoTexto(item.sexo) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Fecha de Nacimiento: {{ item.fechanac || '' }} - Raza:
                    {{ item.raza || '' }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Fecha de Salida: {{ item.salida || '' }} - Por:
                    {{ item.tipo_salida || '' }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Código Ganado: {{ item.codigo_rubro }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <!-- Contenedor con scroll horizontal y vertical -->
        <!-- <v-col cols="12">
          <div
            style="
              overflow-y: auto;
              max-height: 400px;
              width: 100%;
              border: 1px solid #ccc;
            "
          >
            <table class="custom-table">
              <thead>
                <tr>
                  <th v-for="header in headers_produccion" :key="header.value">
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in registro.producciones"
                  :key="`producciones-${index}`"
                >
                  <td>
                    <v-btn
                      small
                      color="primary"
                      @click="mostrarFormularioEdicion(index)"
                    >
                      Ver
                    </v-btn>
                  </td>

                  <td>
                    <v-select
                      v-model="item.id_actividad_pecuaria"
                      :no-data-text="$vuetify.noDataText"
                      :rules="[r.required]"
                      :items="actividad_pecuaria"
                      item-text="descripcion"
                      item-value="id"
                      label="Rubro*"
                      style="width: 200px"
                      @input="handleActividadChange(index)"
                      @change="
                        () => {
                          if (
                            isDiagnosticoPecuario(item.id_actividad_pecuaria)
                          ) {
                            item.cantidad = null
                            item.produccion = 0
                          } else {
                            item.haespecia = null
                          }
                        }
                      "
                    >
                      <template v-slot:selection="props">
                        <div
                          v-text="props.item[props.parent.$props.itemText]"
                        />
                      </template>
                    </v-select>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.identirubro"
                      placeholder="Código"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="item.cantidad"
                      :rules="[r.float, r.min_num(0), r.max_num(10000000)]"
                      placeholder="Cantidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model.number="item.produccion"
                      :rules="[r.required, r.float, r.min_num(0)]"
                      label="Peso*"
                      outlined
                      style="width: 125px"
                    >
                    </v-text-field>
                  </td>

                  <td>
                    <v-text-field style="width: 10px">
                      <template v-slot:append>
                        <unit-picker
                          :group="`to_${guessUnit(item.id_actividad_pecuaria)}`"
                          @transform="item.produccion = $event"
                        />
                      </template>
                    </v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.fechanac"
                      label="Fecha de nacimiento"
                      outlined
                      type="date"
                      placeholder="yyyy-mm-dd"
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="item.color"
                      style="width: 100px"
                      :items="[
                        'Blanco',
                        'Negro',
                        'Rojo',
                        'Café o Marrón',
                        'Gris',
                        'Rubio o Amarillento',
                        'Manchado (negro y blanco)',
                        'Overo (rojo y blanco)',
                        'Pintado (blanco y marrón o con negro)',
                        'Dorado o Bayo',
                        'Atigrado (franjas oscuras y claras)',
                        'Cintillo Blanco (cara blanca y cuerpo negro)',
                        'Plateado',
                      ]"
                      outlined
                      label="Color"
                      placeholder="Color"
                      dense
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.raza"
                      placeholder="Raza"
                      outlined
                      style="width: 120px"
                    />
                  </td> -->

        <!-- Se omplementara el pasto en otro ModalEstablecimiento -->
        <!--  <v-col
                  v-show="
                    isDiagnosticoPecuario(produccion.id_actividad_pecuaria)
                  "
                  cols="6"
                  md="4"
                >
                  <v-text-field
                    v-model.number="produccion.haespecia"
                    :rules="[r.float, r.min_num(0.1), r.max_num(10000000)]"
                    label="Superficie para pasto"
                    suffix="Ha"
                    outlined
                  />
                </v-col> 
                  <td>
                    <span>{{ item.ugsumespecie }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
         <v-snackbar v-model="snackbarVisible" color="error" timeout="3000">
        {{ snackbarMessage }}
        <v-btn color="white" text @click="snackbarVisible = false"
          >Cerrar</v-btn
        >
      </v-snackbar>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>-->
        <!-- FALTA <v-col v-if="pastoSurfaceOverflow" cols="12">
          <n-text error :fix-required="pastoSurfaceOverflow"
            >La superficie acumulada del pasto en la producción excede la
            superficie para pasto que coloco.</n-text
          >
    </v-col> -->
        <!--          <v-col
            v-if="!isDiagnosticoPecuario(produccion.id_actividad_pecuaria)"
            cols="6"
            md="2"
          >
            <v-text-field
              v-model.number="produccion.cantidad"
              :rules="[r.float, r.min_num(0), r.max_num(10000000)]"
              label="Cantidad"
              suffix="#"
              outlined
            />
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              disabled
              :value="produccion.ugsumespecie"
              :rules="[r.required, r.float, r.min_num(0), r.max_num(10000000)]"
              label="ug"
              outlined
            />
          </v-col> -->

        <!-- Tabla de Engorde - Avances creados desde Producciones -->
        <!--  <v-row v-if="mostrarEngorde" justify="center" class="mx-0">
        <v-col cols="12" class="px-0">
          <div class="text-h5 font-weight-bold">Etapas y Engorde</div>
          <div class="text-h6 black--text">
            Agregue el engorde (peso) de cada animal o del grupo y cada etapa de
            producción
          </div>
        </v-col> 
        <v-col cols="12" class="px-0">
          <div class="text-h6 black--text">
            Agregue el engorde (peso) de cada animal o del grupo y cada etapa de
            producción
          </div>
        </v-col> 

        <v-col cols="12">
          <div
            style="
              overflow-x: auto;
              overflow-y: auto;
              max-height: 400px;
              width: 100%;
              border: 1px solid #ccc;
            "
          >
            <table class="custom-table1">
              <thead>
                <tr>
                  <th v-for="headera in headers_engorde" :key="headera.value">
                    {{ headera.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(fila, index) in registro.engorde" :key="index">
                  <td>
                    <v-autocomplete
                      v-model="fila.id_actividad_pecuaria"
                      :items="actividad_pecuaria"
                      item-text="descripcion"
                      item-value="id"
                      label="Tipo de Animal*"
                      style="width: 200px"
                    />
                  </td>

                  <td>
                    <v-text-field v-model="fila.identirubro" outlined />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.fecha_medicion"
                      type="date"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.etapa_anterior"
                      :items="estado_pecuario"
                      item-text="estado_productivo"
                      item-value="estado_productivo"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.etapa_actual"
                      :items="estado_pecuario"
                      item-text="estado_productivo"
                      item-value="estado_productivo"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.cantidad"
                      label="Cantidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-text-field
                      v-model="fila.medicion"
                      label="Peso"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-select
                      v-model="fila.unidad"
                      :items="unidad_medida"
                      item-text="descripcion"
                      item-value="id"
                      label="Unidad"
                      style="width: 100px"
                      outlined
                    />
                  </td>

                  <td>
                    <v-btn icon @click="eliminarFila(index)">
                      <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      
      <tr class="button-row">
        <td colspan="100%">
          <v-btn
            depressed
            block
            class="primary--text custom-button"
            style="margin-top: 10px"
            @click="handleAddRowAndOtherAction()"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar Engorde
          </v-btn>
        </td>
      </tr>
      </v-row> -->
        <!--  </v-col> -->
        <!-- <button
                    @click="handleAddRowAndOtherAction()"
                    class="btn btn-primary"
                  >
                    Agregar Engorde
            </button> -->
        <!-- </v-row> -->
        <!-- listado dinámico de destinos -->
        <!--  <v-col cols="12">
          <div class="text-h6">VENTAS Y CÁLCULOS DE COMPETITIVIDAD</div>
        </v-col> -->
        <!-- Tabla de Engorde - Avances creados desde Producciones -->
        <!--   <v-row v-if="mostrarEngorde" class="mx-0">
          <v-col cols="4">
            <v-btn
              depressed
              block
              class="primary--text custom-button"
              style="margin-top: 10px"
              @click="handleAddRowAndOtherAction()"
            >
              <v-icon left>mdi-plus</v-icon>
              Agregar Engorde
            </v-btn>
          </v-col> -->
        <!-- AQUI Formulario engorde -->
        <!-- v-col cols="12" v-if="indexEdicionEngorde !== null">
            <v-card outlined class="pa-4 mb-4">
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="
                      registro.engorde[indexEdicionEngorde].fecha_medicion
                    "
                    type="date"
                    label="Fecha que ocurre"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="
                      registro.engorde[indexEdicionEngorde]
                        .id_actividad_pecuaria
                    "
                    :items="actividad_pecuaria"
                    item-text="descripcion"
                    item-value="id"
                    label="Rubro*"
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="registro.engorde[indexEdicionEngorde].codigo_rubro"
                    label="ID del ganado"
                    outlined
                  />
                </v-col> -->
        <!-- <v-col cols="12" md="3">
                  <v-select
                  v-model="registro.engorde[indexEdicionEngorde].etapa_anterior"
                  :items="estado_pecuario"
                  item-text="estado_productivo"
                  item-value="estado_productivo"
                  label="Etapa Productiva Anterior"
                  outlined
                  />
                </v-col> -->
        <!-- <v-col cols="12" md="3">
                  <v-select
                  v-model="registro.engorde[indexEdicionEngorde].etapa_actual"
                  :items="estado_pecuario"
                  item-text="estado_productivo"
                  item-value="estado_productivo"
                  label="Etapa Productiva Actual"
                  outlined
                  />
                </v-col> -->
        <!-- <v-col cols="12" md="3">
                  <v-text-field
                  v-model.number="registro.engorde[indexEdicionEngorde].cantidad"
                  label="Cantidad"
                  outlined
                  />
                </v-col> -->
        <!--   <v-col cols="6" md="3">
                  <v-text-field
                    v-model.number="
                      registro.engorde[indexEdicionEngorde].medicion
                    "
                    label="Peso"
                    outlined
                  />
                </v-col>
                <v-col cols="6" md="3">
                  <v-select
                    v-model="registro.engorde[indexEdicionEngorde].unidad"
                    :items="unidad_medida"
                    item-text="descripcion"
                    item-value="id"
                    label="Unidad"
                    outlined
                  />
                </v-col>
                <v-col cols="6" md="3" class="d-flex align-end">
                  <v-btn color="primary" @click="guardarEngorde">
                    Entrar Engorde
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn icon @click="eliminarFilaEngorde(indexEdicionEngorde)">
                    <v-icon color="red">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            v-for="(fila, index) in registro.engorde"
            :key="index"
          >
            <v-card
              outlined
              class="pa-0 custom-border"
              :style="
                index === indexEdicionEngorde
                  ? 'border: 2.8px solid #ff9800;'
                  : 'border: 2.8px solid #4caf50;'
              "
              @click="editarEngorde(index)"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <strong>Rubro:</strong>
                    {{ descripcionActividad(fila.id_actividad_pecuaria) || '' }}
                    - ID del ganado {{ fila.codigo_rubro || 'Sin ID' }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Peso: {{ fila.medicion }}
                    {{ descripcionUnidad(fila.unidad) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-right">
                    Fecha: {{ fila.fecha_medicion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
 -->
        <!-- <div v-if="mostrarVenta" style="margin-top: 30px">
          <destino
            :destinos="registro.destinos"
            :producciones="registro.producciones"
            :listado-destinos="destino"
            :rubros="actividad_pecuaria"
            :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
          />
        </div> -->

        <!-- <div v-if="mostrarobserva">
          <v-col cols="12">
            <div class="text-h6">Tareas Pendientes y Observaciones</div>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="registro.observacion"
              :rules="[r.max(1000)]"
              label="Tarea_Pendiente, Fecha, Observación"
              auto-grow
              outlined
              rows="1"
            ></v-textarea>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="registro.superficie_para_pasto"
              :rules="[r.required, r.float, () => alertSurfaceOverflow]"
              label="Superficie de pasto*"
              suffix="Ha"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="registro.superficie_para_hacerla_pasto"
              :rules="[r.required, r.float, () => alertSurfaceOverflow]"
              label="Superficie para hacerla pasto*"
              suffix="Ha"
              outlined
            ></v-text-field>
          </v-col>
        </div> -->
        <!-- Campo para ley de beneficio -->
        <!--  <v-col cols="12">
        <v-select
          v-model="registro.ley_beneficio"
          label="Programa"
          :items="programa_gobierno"
          item-text="programa"
          item-value="programa"
          outlined
        />
      </v-col> -->
      </template>

      <v-snackbar v-model="snackbarVisible" color="error">
        {{ snackbarMessage }}
        <v-btn color="white" text @click="snackbarVisible = false"
          >Cerrar</v-btn
        >
      </v-snackbar>
      <!-- </v-row> -->
    </v-form>

    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import uuid from 'uuid/v4'
import debounce from 'lodash.debounce'
import Form from '@/components/js/Form'
import { mapState, mapGetters } from 'vuex'
import { clona } from '../../utilidades'
import {
  //produccion_pecuaria,
  //formulario_pecuaria,
  danotrx,
  //engorde,
  inventario,
  formulario_inventario,
} from '../../modelos'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
//import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
//import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'

export default {
  name: 'Ingreso',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    //ModalEstablecimiento,
    //SituacionDeDesastre,
  },
  props: {
    modal: Boolean,
    modoModal: {
      type: Boolean,
      default: false,
    },
  },
  extends: Form,
  data() {
    return {
      //DRAGON
      //codigo_rubro: '',
      identirubro: '',
      id_actividad_pecuaria: '',
      ganadoNoExisteProducciones: false,
      resultadoBusqueda: [],
      busquedaRealizada: false,
      presionobuscar: false,
      datosCargados: false,
      findeBusqueda: false,
      nuevoPecuario: false,
      registroEncontrado: false,
      mensajeBusqueda: '',
      tipoMensaje: 'info',
      buscandoRegistro: false,
      nuevocoPecuario: false,

      tipoSalidaOptions: [
        { text: 'Al matadero', value: 'Al matadero' },
        { text: 'AutoConsumo', value: 'AutoConsumo' },
        { text: 'Muerte', value: 'Muerte' },
        { text: 'Para comercio', value: 'Para comercio' },
        { text: 'Pérdida', value: 'Pérdida' },
        { text: 'Venta', value: 'Venta' },
        { text: 'Salida hacia otra finca', value: 'Salida hacia otra finca' },
      ],
      criaNacidadOptions: [
        { text: 'Finca', value: 'Finca' },
        { text: 'Comprada', value: 'Comprada' },
      ],
      estatusOptions: [
        { text: 'Activo', value: '1' },
        { text: 'Inactivo', value: '0' },
      ],
      indexEdicionEngorde: null,
      indexEdicion: 0,
      mostrarFormularioEditable: false,
      filaEdicion: null,
      //AQUI
      mostrarInventario: true,
      mostrarProduccion: false,
      mostrarEngorde: false,
      mostrarVenta: false,
      mostrarobserva: false,
      filaVisibleIndex: null,
      color: [
        'Blanco',
        'Negro',
        'Rojo',
        'Café o Marrón',
        'Gris',
        'Rubio o Amarillento',
        'Manchado (negro y blanco)',
        'Overo (rojo y blanco)',
        'Pintado (blanco y marrón o con negro)',
        'Dorado o Bayo',
        'Atigrado (franjas oscuras y claras)',
        'Cintillo Blanco (cara blanca y cuerpo negro)',
        'Plateado',
      ],
      filaEdicion: null,
      //
      llaveid_pecuario: '',
      llaveid_actividad_pecuaria: '',
      llaveidentirubro: '',
      errorin: '',
      errors: {},
      errorn: {},
      errorhas: '',
      fecha: '',
      fecha_fin: '',
      año: '',
      mes: '',
      duracionProduccion: null,
      estaditi: '',
      tabla_principal_id: 'id',
      //tabla_produccion_id_rubro: 'id_actividad_pecuaria',
      ruta_registros: 'inventarios',
      ruta_registro: 'inventario',
      nombre_registros_en_state: 'inventarios',
      nombre_registro_en_state: 'inventario',
      dispatch_get_registro: 'getInventarios',
      dispatch_guardar_registro: 'guardarInventario',
      registro: clona(inventario),
      producciones: [],
      //registro_producciones: clona(inventario),
      //engorde: clona(engorde),
      pastoSurfaceOverflow: false,
      filtro: {
        id_actividad_pecuaria: null,
        identirubro: null,
      },
      //registro: [],
      //engorde: [],
      //engordeSeleccionado: [],
      identirubroSeleccionado: null, // Mantendrá el identirubro actualmente seleccionado
      idActividadSeleccionada: null, // ID de la actividad seleccionada
      // registrosSeleccionados: [],
      snackbarVisible: false,
      snackbarMessage: '',

      dialogoAbierto: false,

      sexoOptions: [
        { text: 'HEMBRA', value: 1 },
        { text: 'MACHO', value: 2 },
      ],
    }
  },

  computed: {
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'getMatchingRecords',
      'productor_actual',
    ]),
    ...mapState('listados', [
      'actividad_pecuaria',
      'programa_gobierno',
      'estado_pecuario',
      'unidad_medida',
      'tipo_parcela',
    ]),
    ...mapGetters('listados', ['unidadMedidaPorId']),

    años() {
      const añoActual = new Date().getFullYear()
      const años = []

      // Agregar los últimos 10 años en formato "YYYY - YYYY"
      for (let i = 0; i < 10; i++) {
        const añoInicio = añoActual - i
        const añoFin = añoInicio + 1
        años.push({
          texto: `${añoInicio} - ${añoFin}`,
          valor: añoInicio, // o puedes usar un objeto con ambos años
        })
      }

      return años
    },
    sexoTexto() {
      return (sexoValue) => {
        const opcion = this.sexoOptions.find((item) => item.value == sexoValue)
        return opcion ? opcion.text : 'N/A'
      }
    },
    fechasSugeridas() {
      const pecuarias = this.$store.state.registros.pecuarias
      if (!this.registro.id_finca || !this.registro.id_parcela) return []

      const fechas = Object.values(pecuarias)
        .filter(
          (p) =>
            p.id_finca === this.registro.id_finca &&
            p.id_parcela === this.registro.id_parcela
        )
        .map((p) => p.fecha)

      return [...new Set(fechas)].sort((a, b) => b.localeCompare(a))
    },

    /* alertSurfaceOverflow() {
      const id = this.registro.id
      const id_finca = this.registro.id_finca
      const year = (date) => new Date(date).getFullYear()
      const pecuarias = this.getMatchingRecords({
        recordName: 'pecuarias',
        matchValues: [
          { key: 'id_finca', value: id_finca },
          { key: 'ciclo', value: this.registro.ciclo },
        ],
        exceptIds: [id],
      })
      const fincas = this.getMatchingRecords({
        recordName: 'fincas',
        matchValues: [{ key: 'id', value: id_finca }],
      })
      const superficies_pecuarias_para_pasto = pecuarias
        .filter((p) => year(p.fecha) === year(this.registro.fecha))
        .map((p) => p.superficie_para_pasto)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      const superficies_pecuarias_para_hacerlas_pasto = pecuarias
        .filter((p) => year(p.fecha) === year(this.registro.fecha))
        .map((p) => p.superficie_para_hacerla_pasto)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      const overflow =
        superficies_pecuarias_para_pasto +
          superficies_pecuarias_para_hacerlas_pasto +
          parseFloat(this.registro.superficie_para_pasto) +
          parseFloat(this.registro.superficie_para_hacerla_pasto) >
        parseFloat(fincas?.[0]?.extension ?? 0)
      return (
        !overflow ||
        'La suma de las superficies para este año, ciclo y finca exceden la superficie de la finca'
      )
    }, */
  },

  watch: {
    'registro.tipo_salida'(nuevoValor) {
      const salidasQueBajanEstatus = [
        'Al matadero',
        'AutoConsumo',
        'Muerte',
        'Para comercio',
        'Pérdida',
        'Salida hacia otra finca',
      ]

      if (salidasQueBajanEstatus.includes(nuevoValor)) {
        this.registro.estatus = '0'
      } else {
        this.registro.estatus = '1'
      }
    },

  },

  mounted() {
    this.$store.commit('ui/updateToolbar', 'Pecuario')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
    } else {
      this.registro = clona(formulario_inventario)
    
    }

    this.registro.id_productor = this.productor_actual

  },

  methods: {
    cantidad_vendida_inversa() {
      let produccion = this.registro.produccion
      let vendido = this.registro.cantidad_vendida
      if (this.registro.unidad_produccion === 'lb') {
        produccion = produccion * this.lb_to_kg
      }
      if (this.registro.unidad_cantidad_vendida === 'lb') {
        vendido = vendido * this.lb_to_kg
      }
      return vendido > produccion
    },
    async verificarGanadoExistente() {
      if (!this.identirubro || !this.id_actividad_pecuaria) {
        this.$toast?.error?.(
          'Debe ingresar un código y seleccionar un tipo de ganado.'
        )
        return
      }

      try {
        const res = await this.$store.dispatch('registros/listarInventarios', {
          id_productor: this.productor_actual,
          id_actividad_pecuaria: this.id_actividad_pecuaria,
          identirubro: this.identirubro,
        })

        const ganado = res?.data?.[0]

        if (!ganado) {
          this.$toast?.info?.('No se encontró el ganado con ese código.')
          return
        }

        this.indexEdicion = 0
        this.registro = {
          ...this.registro,
          ...ganado,
        }

        this.$toast?.success?.('Ganado encontrado y cargado.')
      } catch (error) {
        console.error(error)
        this.$toast?.error?.('Error al buscar el ganado.')
      }
    },

    onFincaChange() {
      // Ejecutar la función original para cargar fincas/parcelas disponibles
      this.debounceBuscarRegistroExistente()
      // Ejecutar la función para buscar registro
      //this.debounceBuscarRegistroPorCriterios()
    },

    async buscarRegistroPorCriterios() {
      // Si la búsqueda inicial ya se completó, no hagas nada más.
      if (this.busquedaFin) {
        return
      }

      if (
        !this.registro.id_finca ||
        !this.registro.id_parcela ||
        !this.registro.fecha
      ) {
        this.limpiarMensaje()
        return
      }
      this.buscandoRegistro = true
      this.limpiarMensaje()
      try {
        const registroExistente = this.buscarRegistroLocal()
        if (registroExistente) {
          await this.traerRegistroYNavegar(registroExistente)
        } else {
          // Si no está en local, buscar en servidor
          await this.buscarRegistroEnServidor()
        }
      } catch (error) {
        this.registroNoEncontrado()
      } finally {
        this.buscandoRegistro = false
      }
    },
    buscarRegistroLocal() {
      // Buscar en el store de forestales
      const pecuarias = this.$store.state.registros.pecuarias
      return Object.values(pecuarias).find(
        (pecuaria) =>
          pecuaria.id_finca === this.registro.id_finca &&
          pecuaria.id_parcela === this.registro.id_parcela &&
          pecuaria.fecha === this.registro.fecha
      )
    },
    async buscarRegistroEnServidor() {
      try {
        const response = await this.$store.dispatch(
          'registros/listarPecuariasx',
          {
            id_productor: this.registro.id_productor,
            id_finca: this.registro.id_finca,
            id_parcela: this.registro.id_parcela,
            // solo el año porque el backend filtra por año
            fecha: this.registro.fecha,
          }
        )

        if (response && response.success && Array.isArray(response.data)) {
          const fechaBuscada = this.registro.fecha
          const registroExacto = response.data.find((r) => {
            const fechaApi = r.fecha ? r.fecha.split('T')[0] : null
            return fechaApi === fechaBuscada
          })

          if (registroExacto) {
            await this.traerRegistroYNavegar(registroExacto)
          } else {
            this.registroNoEncontrado()
          }
        } else {
          this.registroNoEncontrado()
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.registroNoEncontrado()
        } else {
          throw error
        }
      }
    },

    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getPecuaria', { id: registro.id })
      }
      this.$router.push(`/ru/pecuario/${registro.id}`)
      this.esEditable = false
      this.busquedaFin = true
    },

    mostrarMensaje(mensaje, tipo) {
      this.mensajeBusqueda = mensaje
      this.tipoMensaje = tipo
    },

    limpiarMensaje() {
      this.mensajeBusqueda = ''
      this.tipoMensaje = 'info'
    },
    descripcionActividad(id) {
      const act = this.actividad_pecuaria.find((a) => a.id === id)
      return act ? act.descripcion : 'Desconocido'
    },
    convertirDatosSexo() {
      if (this.registro.producciones) {
        this.registro.producciones.forEach((produccion) => {
          // Convertir número a string para que coincida con los values del select
          if (produccion.sexo !== null && produccion.sexo !== undefined) {
            produccion.sexo = produccion.sexo.toString()
          }
        })
      }
    },
    agregarProduccionYEditar() {
  const nuevo = this.crearRegistroVacio()
  
  if (this.indexEdicion !== null) {
    this.producciones.splice(this.indexEdicion + 1, 0, nuevo)
    this.indexEdicion = this.indexEdicion + 1
  } else {
    this.producciones.unshift(nuevo)
    this.indexEdicion = 0
  }
  
  this.registro = { ...nuevo }
},

    pmostrarIngreso() {
      this.mostrarInventario = true
      this.mostrarEngorde = false
      this.mostrarVenta = false
    },
    pmostrarEngorde() {
      this.mostrarInventario = false
      this.mostrarEngorde = true
      this.mostrarVenta = false
    },
    pmostrarVenta() {
      this.mostrarInventario = false
      this.mostrarEngorde = false
      this.mostrarVenta = true
    },
    editarProduccion(index) {
      this.indexEdicion = index
      this.registro = clona(this.producciones[index])
    },

    guardarEntrada() {
       if (!this.$refs.form.validate()) {
          this.$store.commit('ui/setSnack', {
            text: 'Verifique los elementos en rojo',
            color: 'error',
          })
          return ''
        }
      // Asegura que el registro en edición se guarde en el array
      if (this.indexEdicion !== null) {
        this.producciones[this.indexEdicion] = clona(this.registro)
      }

      // Sale del modo edición
      this.indexEdicion = null
    },
    crearRegistroVacio() {
      return {
        id_actividad_pecuaria: null,
        identirubro: '',
        id_finca: null,
        cantidad: null,
        sexo: null,
        peso_inicial: null,
        fechanac: '',
        raza: '',
        color: '',
        origen: '',
        codigop: '',
        codigom: '',
        nombre_ganado: '',
        salida: '',
        tipo_salida: '',
        estatus: '1',
      }
    },
    editarProduccion(index) {
      this.registro = { ...this.producciones[index] }
      this.indexEdicion = index
    },
    eliminarFilaProduccion(index) {
      if (this.producciones.length === 1) {
        // Si solo hay una, no eliminarla completamente, solo vaciarla
        this.producciones[0] = clona(formulario_inventario)
        this.indexEdicion = 0
        this.registro = clona(this.producciones[0])
      } else {
        this.producciones.splice(index, 1)

        // Ajustar el indexEdicion
        if (index >= this.producciones.length) {
          this.indexEdicion = this.producciones.length - 1
        } else {
          this.indexEdicion = index
        }
        this.registro = clona(this.producciones[this.indexEdicion])
      }
    },
    //////////   DRAGON ///////////////
    mostrarFormularioEdicion(index) {
      const item = this.registro.producciones[index]
      // Hacemos una copia editable para no afectar en tiempo real la tabla
      this.filaEdicion = { ...item }
      this.filaVisibleIndex = index
      this.mostrarFormularioEditable = true
    },
    ocultarFormulario() {
      // DRAGON Guarda los cambios en la tabla original
      if (this.filaVisibleIndex !== null) {
        this.$set(this.registro.producciones, this.filaVisibleIndex, {
          ...this.filaEdicion,
        })
      }
      this.filaVisibleIndex = null
      this.mostrarFormularioEditable = false
      this.filaEdicion = null
    },
    /////////////////////
    aplicarFiltro(produccion) {
      // Actualiza los criterios de filtro
      this.filtro.id_actividad_pecuaria = produccion.id_actividad_pecuaria
      this.filtro.identirubro = produccion.identirubro
    },
    limpiarDestinosYGuardar() {
      // Verificar si algún destino tiene el campo 'rubro' vacío
      const destinosConRubroVacio = this.registro.destinos.filter(
        (destino) => !destino.rubro
      )
      // Si hay destinos con el campo 'rubro' vacío
      if (destinosConRubroVacio.length > 0) {
        // Mostrar una alerta (por ejemplo con v-snackbar o alert, dependiendo de lo que prefieras)
        this.snackbarMessage =
          'Es requerido cerrar la venta si no se está incluyendo venta válida.'
        this.snackbarVisible = true
      } else {
        // Filtrar destinos con rubro lleno
        this.registro.destinos = this.registro.destinos.filter(
          (destino) => destino.rubro
        )
      }
      //console.log('Registro limpio:', this.registro)
    },

    inicializarProducciones() {
      if (this.registro.producciones.length < 1) {
        while (this.registro.producciones.length < 1) {
          this.addRow()
        }
      }

      if (this.registro.engorde.length < 1) {
        while (this.registro.engorde.length < 1) {
          this.AgregarEngorde()
        }
      }
      this.registro.producciones = this.registro.producciones.map(
        (produccion) => ({
          ...produccion,
          costo_inicial:
            typeof produccion.costo_inicial !== 'undefined'
              ? produccion.costo_inicial
              : '0',
          estatus: produccion.estatus || '1',
          identirubro: produccion.identirubro || '',
          haespecia: produccion.haespecia || '',
          ugequivalente: produccion.ugequivalente || '',
          unidad: produccion.unidad || '',
        })
      )
    },
    addRow() {
      this.registro.producciones.push({
        id_actividad_pecuaria: '',
        identirubro: '0',
        fechanac: '',
        color: '',
        raza: '',
        cantidad: '',
        peso_inicial: '0',
        ugsumespecie: '',
        costo_inicial: 0,
        unidad: '',
        //ugequivalente: '',
        estatus: '',
      })
    },
    /* AgregarEngorde() {
      const nuevoEngorde = {
        id_actividad_pecuaria: null,
        codigo_rubro: '',
        fecha_medicion: new Date().toISOString().substr(0, 10),
        etapa_anterior: null,
        etapa_actual: null,
        cantidad: null,
        medicion: null,
        unidad: null,
      }
      this.registro.engorde.unshift(nuevoEngorde)
      this.$nextTick(() => {
        this.indexEdicionEngorde = 0
      })
    }, */
    editarEngorde(index) {
      this.indexEdicionEngorde = index
    },
    guardarEngorde() {
      this.indexEdicionEngorde = null
    },

    /*  esEngordeValido(fila) {
      return (
        fila.id_actividad_pecuaria && fila.codigo_rubro && fila.fecha_medicion
      )
    },
 */
    esEntradaValida(item) {
      return item.id_actividad_pecuaria
    },

    esDestinoValido(destino) {
      return destino.rubro
    },

    descripcionUnidad(idUnidad) {
      const unidad = this.unidad_medida.find((u) => u.id === idUnidad)
      return unidad ? unidad.descripcion : ''
    },

    handleAddRowAndOtherAction() {
      this.AgregarEngorde()
    },

    handleFechaChange() {
      this.validarFecha() // Validar la fecha de inicio
      this.validarFechahas() // Validar la fecha de fin
      if (this.registro.fecha && this.registro.fecha_fin) {
        this.debounceBuscarRegistroExistente()
        this.calcularDuracionProduccion()
      }
    },

    setFechaInicio() {
      const today = new Date()
      const dia = today.getDate().toString().padStart(2, '0')
      const mes = (today.getMonth() + 1).toString().padStart(2, '0') // getMonth() es 0-indexado
      const anio = today.getFullYear()
      this.registro.fecha = `${dia}-${mes}-${anio}`
    },

    validarFecha() {
      // Expresión regular para formato aaaa-mm-dd
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      const fecha = this.registro.fecha

      if (!regexFecha.test(fecha)) {
        this.errorin =
          'Favor colocar año, mes y día separados con guiones así: aaaa-mm-dd'
      } else {
        let [, anio, mes, dia] = fecha.match(regexFecha)
        const diaInt = parseInt(dia, 10)
        const mesInt = parseInt(mes, 10)
        const anioInt = parseInt(anio, 10)

        if (mesInt < 1 || mesInt > 12) {
          this.errorin = 'El mes debe estar en el rango de 1 a 12.'
          return
        }

        let diasEnMes = new Date(anioInt, mesInt, 0).getDate()
        if (diaInt < 1 || diaInt > diasEnMes) {
          this.errorin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
          return
        }

        this.errorin = ''
      }
    },

    validarFechaNac(fechaNac) {
      const claveError = 'fechanac'

      if (!fechaNac) {
        this.$set(this.errorn, claveError, '')
        return true
      }

      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(fechaNac)) {
        this.$set(
          this.errorn,
          claveError,
          'Formato incorrecto. Use aaaa-mm-dd (ej: 2025-08-04)'
        )
        return false
      }

      const [, anio, mes, dia] = fechaNac.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.$set(this.errorn, claveError, 'El mes debe estar entre 1 y 12.')
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.$set(this.errorn, claveError, `El día no es válido para el mes.`)
        return false
      }

      this.$set(this.errorn, claveError, '')
      return true
    },
    validarFechaSalida(fechaSalida) {
      if (!fechaSalida) {
        this.$set(this.errors, 'salida', [])
        return true
      }

      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(fechaSalida)) {
        this.$set(this.errors, 'salida', ['Formato inválido. Usa aaaa-mm-dd'])
        return false
      }

      const [, anio, mes, dia] = fechaSalida.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.$set(this.errors, 'salida', ['El mes debe estar entre 01 y 12'])
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.$set(this.errors, 'salida', [
          `El día no es válido para el mes ${mesInt}`,
        ])
        return false
      }

      this.$set(this.errors, 'salida', [])
      return true
    },
    //función que formatea la fecha para enviarla a la BD
    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    //Función que formatea la fecha que que se trae de la BD para mostrarla en el front
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },
    //funcion para limpiar los array vacios antes de guardar
    limpiarRegistrosVacios() {
      this.registro.producciones = this.registro.producciones.filter((item) =>
        this.esEntradaValida(item)
      )
      this.registro.engorde = this.registro.engorde.filter((item) =>
        this.esEngordeValido(item)
      )
      this.registro.destinos = (this.registro.destinos || []).filter((item) =>
        this.esDestinoValido(item)
      )
      this.$nextTick(() => {})
    },

    async antesDeGuardar() {
      await this.$nextTick()
      this.registro.id_productor = this.productor_actual || ''

      if (this.modoModal) {
        // Emitir el nuevo registro al componente padre (Pecuario.vue)
        this.$emit('nuevo-registro', { ...this.registro })
        this.$emit('update:modal', false)
      } else {
        this.indexEdicion = null
      }

      this.guardarYContinuar()
    },
    async guardarYContinuarInventario () {
  try {
    this.loading = true;

    // Validar formulario
    if (!this.$refs.form.validate()) {
          this.$store.commit('ui/setSnack', {
            text: 'Verifique los elementos en rojo',
            color: 'error',
          })
          return ''
        }
      
    // Enviar cada registro al backend
    for (const r of this.producciones) {
       if (!r.id_productor) r.id_productor = this.productor_actual;

      if (!this.obtenerIdDeRuta(r)) {
          r[this.tabla_principal_id] = uuid()
          r.created_at = new Date().getTime() / 1000
        } else r.updated_at = new Date().getTime() / 1000

      await this.$store.dispatch(
        `registros/${this.dispatch_guardar_registro}`,
        clona(r)
      );
    }
    this.$router.push(`/ru/${this.ruta_registros}`);
  } catch (error) {
    this.$sentry.captureException(error);
  } finally {
    this.loading = false;
  }
},
    calcularDuracionProduccion() {
      const fecha = new Date(this.registro.fecha)
      const fecha_fin = new Date(this.registro.fecha_fin)

      if (!isNaN(fecha) && !isNaN(fecha_fin)) {
        const aniosDiferencia = fecha_fin.getFullYear() - fecha.getFullYear()
        const mesesDiferencia = fecha_fin.getMonth() - fecha.getMonth()
        this.registro.duracionProduccion =
          aniosDiferencia * 12 + mesesDiferencia
      } else {
        this.registro.duracionProduccion = 0 // Si alguna fecha no es válida, asigna 0
      }
    },

    isDiagnosticoPecuario(id_cultivo) {
      return (
        this.getRubroById(id_cultivo)?.clasificacion === 'ADIAGNOSTICO PECUARIO'
      )
    },

    //no se usa
    getRubroById(id_cultivo) {
      return this.actividad_pecuaria.find((ap) => ap.id === id_cultivo)
    },

    calculatePastoSurfaceAndWarn() {
      let surfaceSum = 0
      for (const prod of this.registro?.producciones) {
        // calcula que la suma de superfices no exceda la del formulario
        if (!isNaN(parseFloat(prod.haespecia)) && prod.haespecia > 0) {
          surfaceSum += parseFloat(prod.haespecia)
        }

        this.pastoSurfaceOverflow =
          surfaceSum > this.registro.superficie_para_pasto ? true : false
      }
    },

    guessUnit(id_rubro) {
      const rubro = this.actividad_pecuaria.find((a) => a.id === id_rubro)
      return this.unidadMedidaPorId(rubro?.id_unidad_medida ?? 2)
    },

    handleActividadChange() {
      if (this.registro.id_actividad_pecuaria) {
        const rubro = this.actividad_pecuaria.find(
          (a) => a.id === this.registro.id_actividad_pecuaria
        )
        this.registro.cantidad = 1
        this.registro.estatus = '1'
      }
    },
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela
        const id_rubros = !this.obtenerIdDeRuta()
          ? this.registro.producciones
              .filter((prod) => !!prod.id_actividad_pecuaria)
              .map((prod) => prod.id_actividad_pecuaria)
          : []

        if (id_rubros.length === 0) {
          id_rubros = []
        }

        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        // required fields to be fulfilled
        if (ciclo && fecha && id_finca && rubros) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarPecuariasx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
              id_rubros,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },

    Cancelar() {
      this.$router.push('/ru/pecuarios')
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },

    eliminarFilaEngorde(index) {
      this.registro.engorde.splice(index, 1)
      this.indexEdicionEngorde = null
    },
  },
}
</script>
<style scoped>
/* .overflow-container {
  overflow-x: auto;
  width: 100%;
  margin: 0 auto;
  /* max-width: 100%;
} */
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}

.error-text {
  color: red;
  font-size: 0.875rem;
}

.button-row td {
  border: none;
  padding: 0;
  text-align: center;
}

.button-row {
  margin: 16px 0;
  /* Agrega espacio alrededor */
}

.custom-table {
  min-width: 500px;
  width: 100%;
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ccc;
}

.custom-table th.header {
  font-size: 15px;
}
.custom-table th {
  background-color: #050505ef;
  text-align: center;
  color: #fff;
}

.custom-table1 {
  min-width: 500px;
  width: 100%;
  border-collapse: collapse;
}

.custom-table1 th,
.custom-table1 td {
  text-align: center;
  border: 1px solid #ccc;
  padding: 8px;
}

@media (max-width: 768px) {
  .custom-table1 th,
  .custom-table1 td {
    font-size: 12px; /* Reducir tamaño de fuente */
  }
}

.custom-table1 th.headera {
  font-size: 15px;
}

.custom-table1 th {
  background-color: #050505ef;
  text-align: center;
  color: #fff;
}

.table-container {
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  height: auto;
}

.elevation-1 {
  max-width: 100%;
  /* Asegura que el contenedor de la tabla se expanda completamente */
  /* overflow-x: auto; */
  /* Permite que la tabla sea desplazable si es más ancha que su contenedor */
}

/* .btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 8px;
  cursor: pointer;
  transition: background-color 0.3s;
} */

/* .btn-primary:hover {
  background-color: #0056b3;
} */

/* .btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
} */

/* .btn-secondary:hover {
  background-color: #5a6268;
} */

.production-field {
  display: flex;
  align-items: center;
}

.production-field .v-input__control {
  display: flex;
  align-items: center;
}

.production-field .v-input__control > * {
  margin-right: 4px;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
</style>